<!--
 * @Description: 合作伙伴新增 [基本信息-base ，对接人信息，市场活动信息]
 * @Author: cxh
 * @Date: 2022-06-13 16:21:49
 * @LastEditTime: 2023-04-20 15:09:08
 * @LastEditors: cxh
-->
<template>
  <a-form name="detailsForm" ref="formRef" :model="form">
    <dc-layout-card title="基本信息" v-if="content.includes('partnerBase')">
      <dc-form-item label="合作伙伴名称" name="name" :rules="[{ required: true, message: '请输入' }]">
        <CosInput v-model:value="form.name" allowClear placeholder="请输入" :disabled="disabled" :view="view" />
      </dc-form-item>
      <dc-form-item
        label="评级"
        name="starGrade"
        :rules="{ required: true, validator: selectForNumberValidate, message: '请选择' }"
      >
        <CosSelect
          v-model:value="form.starGrade"
          allowClear
          placeholder="请选择"
          :options="dataConfig.starGrade"
          :disabled="disabled"
          filterNoVal
          :view="view"
        />
      </dc-form-item>
      <dc-form-item
        label="知名度"
        name="popularityDegree"
        :rules="[{ required: true, validator: selectForNumberValidate, message: '请选择' }]"
      >
        <CosSelect
          v-model:value="form.popularityDegree"
          allowClear
          placeholder="请选择"
          :options="[...Array(10)].map((_, i) => ({ value: i + 1, label: i + 1 }))"
          :disabled="disabled"
          filterNoVal
          :view="view"
        />
      </dc-form-item>
      <dc-form-item
        label="契合度"
        name="agreementDegree"
        :rules="[{ required: true, validator: selectForNumberValidate, message: '请选择' }]"
      >
        <CosSelect
          v-model:value="form.agreementDegree"
          allowClear
          placeholder="请选择"
          :options="[...Array(10)].map((_, i) => ({ value: i + 1, label: i + 1 }))"
          :disabled="disabled"
          filterNoVal
          :view="view"
        />
      </dc-form-item>
      <dc-form-item
        label="关系"
        name="relationDegree"
        :rules="[{ required: true, validator: selectForNumberValidate, message: '请选择' }]"
      >
        <CosSelect
          v-model:value="form.relationDegree"
          allowClear
          placeholder="请选择"
          :options="[...Array(10)].map((_, i) => ({ value: i + 1, label: i + 1 }))"
          :disabled="disabled"
          filterNoVal
          :view="view"
        />
      </dc-form-item>
      <dc-form-item
        label="合作伙伴区域"
        name="regionId"
        :rules="[{ required: true, validator: selectForNumberValidate, message: '请选择' }]"
      >
        <ParamCodesSelect
          :options="paramCodeData.zbu_partner_area_lbu"
          v-model:value="form.regionId"
          :disabled="disabled"
          filterNoVal
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="Base地" name="areaId" :rules="[{ required: true, message: '请选择' }]">
        <CustomerArea
          v-model:value="form.areaId"
          v-model:label="form.areaName"
          :disabled="disabled"
          change-on-select
          :view="view"
        />
      </dc-form-item>
      <dc-form-item
        label="性质"
        name="property"
        :rules="[{ required: true, validator: selectForNumberValidate, message: '请选择' }]"
      >
        <ParamCodesSelect
          :options="paramCodeData.zbu_partner_nature_lbu"
          v-model:value="form.property"
          :disabled="disabled"
          filterNoVal
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="主要客群" name="mainCustomers" :rules="[{ required: true, message: '请选择' }]">
        <ParamCodesSelect
          :options="paramCodeData.zbu_main_customers_lbu"
          v-model:value="form.mainCustomers"
          :disabled="disabled"
          mode="multiple"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="市场活动类型" name="activityTypes" :rules="[{ required: true, message: '请选择' }]">
        <ParamCodesSelect
          :options="paramCodeData.zbu_campaign_type_lbu"
          v-model:value="form.activityTypes"
          :disabled="disabled"
          mode="multiple"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="市场活动计划" name="activityPlan">
        <CosInput
          v-model:value.trim="form.activityPlan"
          allowClear
          placeholder="请输入"
          :disabled="disabled"
          :view="view"
        />
      </dc-form-item>
      <dc-form-item label="网站/公众号" name="webSite">
        <CosInput v-model:value.trim="form.webSite" allowClear placeholder="请输入" :disabled="disabled" :view="view" />
      </dc-form-item>
      <dc-form-item label="合作伙伴简介" name="intro" :span="12">
        <CosTextarea v-model:value="form.intro" placeholder="请输入" :disabled="disabled" :view="view" />
      </dc-form-item>
    </dc-layout-card>
    <dc-layout-card title="对接人信息" v-if="content.includes('partnerContact')">
      <dc-form-item
        label="对接人名称"
        :name="['partnerContact', 'name']"
        :rules="[{ required: true, message: '请输入' }, { validator: concatNameValidate }]"
      >
        <CosInput v-model:value.trim="form.partnerContact.name" allowClear placeholder="请输入" :disabled="disabled" />
      </dc-form-item>
      <dc-form-item label="性别" name="sex">
        <CosSelect
          v-model:value="form.partnerContact.sex"
          allowClear
          placeholder="请选择"
          :options="dataConfig.genderEnum"
          :disabled="disabled"
          filterNoVal
        />
      </dc-form-item>
      <dc-form-item label="角色" name="role">
        <ParamCodesSelect
          :options="paramCodeData.zbu_partner_role_lbu"
          v-model:value="form.partnerContact.role"
          :disabled="disabled"
          filterNoVal
        />
      </dc-form-item>
      <dc-form-item
        label="手机"
        :name="['partnerContact', 'mobile']"
        :rules="[{ validator: (rule, value) => contactValidate(rule, value, form.partnerContact, formRef) }]"
      >
        <CosInput
          v-model:value="form.partnerContact.mobile"
          allowClear
          placeholder="请输入，联系方式必填其一"
          :disabled="disabled"
        />
      </dc-form-item>
      <dc-form-item
        label="邮箱"
        :name="['partnerContact', 'email']"
        :rules="[
          {
            validator: (rule, value) => contactValidate(rule, value, form.partnerContact, formRef)
          }
        ]"
      >
        <CosInput
          v-model:value.trim="form.partnerContact.email"
          allowClear
          placeholder="请输入，联系方式必填其一"
          :disabled="disabled"
        />
      </dc-form-item>
      <dc-form-item
        label="微信号"
        :name="['partnerContact', 'wechat']"
        :rules="{
          validator: (rule, value) => contactValidate(rule, value, form.partnerContact, formRef)
        }"
      >
        <CosInput
          v-model:value.trim="form.partnerContact.wechat"
          allowClear
          placeholder="请输入，联系方式必填其一"
          :disabled="disabled"
        />
      </dc-form-item>
      <dc-form-item
        label="QQ号"
        :name="['partnerContact', 'qq']"
        :rules="{
          validator: (rule, value) => contactValidate(rule, value, form.partnerContact, formRef),
          trigger: 'blur'
        }"
      >
        <CosInput
          v-model:value.trim="form.partnerContact.qq"
          allowClear
          placeholder="请输入，联系方式必填其一"
          :disabled="disabled"
        />
      </dc-form-item>
      <dc-form-item
        label="固定电话"
        :name="['partnerContact', 'tel']"
        :rules="{
          validator: (rule, value) => contactValidate(rule, value, form.partnerContact, formRef)
        }"
      >
        <CosInput
          v-model:value.trim="form.partnerContact.tel"
          allowClear
          placeholder="请输入，联系方式必填其一"
          :disabled="disabled"
        />
      </dc-form-item>
      <a-col :span="24" />
      <dc-form-item label="备注" name="remark" :span="12">
        <CosTextarea
          v-model:value="form.partnerContact.remark"
          :maxlength="2000"
          placeholder="请输入"
          :disabled="disabled"
        />
      </dc-form-item>
    </dc-layout-card>
    <dc-layout-card title="市场活动信息" v-if="content.includes('partnerActivity')">
      <dc-form-item
        label="活动名称"
        :name="['partnerActivity', 'name']"
        :rules="[{ required: activityRequired, message: '请输入' }]"
      >
        <CosInput v-model:value.trim="form.partnerActivity.name" allowClear placeholder="请输入" :disabled="disabled" />
      </dc-form-item>
      <dc-form-item label="活动时间" name="time">
        <cos-range-picker
          v-model:startTime="form.partnerActivity.startTime"
          v-model:endTime="form.partnerActivity.endTime"
          :disabled="disabled"
        />
      </dc-form-item>
      <dc-form-item
        label="活动费用"
        :name="['partnerActivity', 'cost']"
        :rules="[{ required: activityRequired, message: '请输入' }]"
      >
        <CosInputNumber
          v-model:value="form.partnerActivity.cost"
          :maxlength="15"
          :min="0"
          :precision="2"
          allowClear
          placeholder="请输入"
          :disabled="disabled"
          style="width: 100%"
        />
      </dc-form-item>
      <dc-form-item
        label="是否参加"
        :name="['partnerActivity', 'joinFlag']"
        :rules="[{ required: activityRequired, message: '请选择', validator: selectForNumberValidate }]"
      >
        <CosSelect
          v-model:value="form.partnerActivity.joinFlag"
          allowClear
          placeholder="请选择"
          :disabled="disabled"
          :options="dataConfig.joinFlag"
        />
      </dc-form-item>
      <dc-form-item label="活动区域" name="areaId">
        <CustomerArea
          v-model:value="form.partnerActivity.areaId"
          v-model:label="form.partnerActivity.areaName"
          change-on-select
          :disabled="disabled"
        />
      </dc-form-item>
      <a-col :span="18" />
      <dc-form-item label="活动效果评估" name="resultEvaluate" :span="12">
        <CosTextarea
          v-model:value="form.partnerActivity.resultEvaluate"
          :maxlength="2000"
          placeholder="请输入"
          :disabled="disabled"
        />
      </dc-form-item>
    </dc-layout-card>
  </a-form>
  <cos-footer-button
    v-model:value="form"
    :resetValue="resetValue"
    :formRef="formRef"
    :permissionPage="permissionPage"
    :loading="loading"
    :editUrl="`/lbu/partnerManage/edit?id=${route.query.id}`"
    @submit="handleSubmit"
    :disabled="disabled"
  >
  </cos-footer-button>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { partnerEdit, partnerAdd, partnerDetail } from '@/api/marketing/marketingManage'
import { listByParamCodes } from '@/api/common'
import type { PartnerManage } from '@/typings/api/marketingManage'
import dataConfig from '@/views/marketing/commonEnum/dataConfig'
import { message } from '@dc-platform/dc-components'
import { contactValidate, selectForNumberValidate, concatNameValidate } from '@/utils/validate'
import CustomerArea from '@/components/CustomerArea'
import { goBack } from '@/hooks/cosRouter'
import { cloneDeep } from 'lodash-es'
import { paramCodesDataFilter } from '@/utils/index'

const props = defineProps({
  disabled: {
    type: Boolean,
    default: true
  },
  permissionPage: {
    type: Object
  },
  view: {
    type: Boolean
  },
  content: {
    type: Array,
    default: () => {
      return ['partnerBase', 'partnerContact', 'partnerActivity']
    }
  }
})
const paramCodeData = ref<{
  zbu_grade_lbu: []
  zbu_partner_nature_lbu: []
  zbu_main_customers_lbu: []
  zbu_campaign_type_lbu: []
  zbu_partner_area_lbu: []
  zbu_popularity_lbu: []
  zbu_partner_role_lbu: []
}>({
  zbu_grade_lbu: [], // 评级
  zbu_partner_nature_lbu: [], // 合作伙伴性质
  zbu_main_customers_lbu: [], // 主要客群
  zbu_campaign_type_lbu: [], // 市场活动类型
  zbu_partner_area_lbu: [], // 合作伙伴区域
  zbu_popularity_lbu: [], // 知名度
  zbu_partner_role_lbu: [] // 合作伙伴角色
})
const formRef = ref()
const form = ref<PartnerManage>({
  partnerActivity: {},
  partnerContact: {}
})
const resetValue = ref<PartnerManage>({
  partnerActivity: {},
  partnerContact: {}
})

const loading = ref(false)
const route = useRoute()
const activityRequired = computed(() => {
  const { name, startTime, cost, joinFlag, areaId, resultEvaluate } = form.value.partnerActivity
  if (name || startTime || cost || joinFlag === true || joinFlag === false || areaId || resultEvaluate) {
    return true
  }
  return false
})
// 获取详情
const fetch = () => {
  if (route.query.id) {
    loading.value = true
    partnerDetail({
      id: route.query.id,
      isForUpdate: true
    })
      .then((res) => {
        form.value = {
          ...res.data,
          partnerActivity: res.data.partnerActivity || {},
          partnerContact: res.data.partnerContact || {}
        }
        resetValue.value = cloneDeep(form.value)
      })
      .finally(() => {
        loading.value = false
      })
  }
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_zbu',
    paramCodes: [
      'zbu_grade_lbu',
      'zbu_partner_nature_lbu',
      'zbu_main_customers_lbu',
      'zbu_campaign_type_lbu',
      'zbu_partner_area_lbu',
      'zbu_partner_role_lbu'
    ]
  }).then((res) => {
    if (res.code === 200) {
      if (!props.view) {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, 0)
      }
      paramCodeData.value = {
        ...res.data
      }
    }
  })
}
const handleSubmit = async () => {
  loading.value = true
  try {
    const rParams: any = cloneDeep(form.value)
    if (!activityRequired.value) {
      console.log(form.value)
      const { partnerActivity } = form.value
      if (partnerActivity) {
        if (partnerActivity.id) {
          rParams.partnerActivity = {
            id: partnerActivity.id
          }
        } else {
          delete rParams.partnerActivity
        }
      }
    }
    if (route.query.id) {
      await partnerEdit(rParams)
      message.success('编辑成功')
    } else {
      await partnerAdd(rParams)
      message.success('新增成功')
    }
    goBack()
    // router.push({
    //   path: '/zbu/partnerManage'
    // })
  } catch (error) {}
  loading.value = false
}
onMounted(() => {
  fetch()
  getByParamCodes()
})
</script>
<script lang="ts">
export default { name: 'BaseMessage' }
</script>
<style scoped></style>
